import type { FormBlockContext } from '#layers/forms/types/form-block';

/** Copies relation foreign-key values into the owning form state when it is available. */
export function syncRelationForeignKeys(formBlockContext: FormBlockContext | null, values: Iterable<readonly [string, unknown]>) {
	const formState = formBlockContext?.state.value;
	if (!formState) return;

	for (const [fieldKey, value] of values) {
		formState[fieldKey] = value;
	}
}
